import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import * as React from 'react';
import { useThemeValue } from '../system';
import { StackView } from '../StackView';
import { Section } from './Section';
import { cloneChildren } from '../utils';
export function Card(_ref) {
  var children = _ref.children,
      subdued = _ref.subdued,
      _ref$radius = _ref.radius,
      radius = _ref$radius === void 0 ? 3 : _ref$radius,
      restProps = _objectWithoutPropertiesLoose(_ref, ["children", "subdued", "radius"]);

  var cardTheme = useThemeValue('card'); // List of component types to ignore when setting the radius
  // for first & last child elements

  var ignoreRadiusTypes = ['Avatar', 'Badge', 'Button', 'Calendar', 'ChurchCenterStatus', 'Group', 'Inline', 'Input', 'InputBox', 'Modal', 'Progress', 'Spinner', 'Status', 'Tab', 'Tooltip'];
  return /*#__PURE__*/React.createElement(StackView, _extends({
    width: "100%",
    lineHeight: 2.5,
    borderColor: "separatorTertiary",
    borderStyle: "solid",
    borderWidth: 1,
    backgroundColor: subdued ? 'surfaceSecondary' : 'surface',
    color: "foreground",
    radius: radius
  }, cardTheme, restProps), radius > 0 ? cloneChildren(children, function (child, _ref2) {
    var _ref3, _ref4;

    var firstChild = _ref2.firstChild,
        lastChild = _ref2.lastChild;
    return child.props.radius === undefined && !ignoreRadiusTypes.includes(child.type.name) ? firstChild ? (_ref3 = {}, _ref3["radius" + (restProps.axis === 'horizontal' ? 'Left' : 'Top')] = radius - 1, _ref3) : lastChild ? (_ref4 = {}, _ref4["radius" + (restProps.axis === 'horizontal' ? 'Right' : 'Bottom')] = radius - 1, _ref4) : {} : {};
  }) : children);
}
Card.Section = Section;